<template>
	<div>
		<dynvibewordcloud
			ref="animatedWordcloud"
			title="Per period Mastertag wordcloud"
			axios="mastertagsListQuery"
			:clickable="false"
		></dynvibewordcloud>
		<input class="range-slider" type="range" v-model="currentIndex" :min="min" :max="max" />
	</div>
</template>

<script>
import dynvibewordcloud from "@/components/vueCharts/DynvibeWordCloud.vue";
export default {
	data() {
		return {
			min: 0,
			max: 3,
			currentIndex: 0,
		};
	},
	components: {
		dynvibewordcloud: dynvibewordcloud,
	},
	methods: {
		addMonths(date, months) {
			let d = date.getDate();
			date.setMonth(date.getMonth() + +months);
			if (date.getDate() != d) {
				date.setDate(0);
			}
			return date;
		},
	},
	watch: {
		currentIndex(newVal) {
			let data = this.$store.getters.parameters;
			let date1 = new Date(data.date.lte);
			let date2 = new Date(data.date.gte);
			date1 = this.addMonths(date1, newVal * 3);
			date2 = this.addMonths(date2, newVal * 3);
			data.date.lte = date1.toISOString().split("T")[0];
			data.date.gte = date2.toISOString().split("T")[0];
			this.$refs.animatedWordcloud.loadComponent(data);
		},
	},
};
</script>

<style></style>
